import { get } from 'utils/rxfetch'

export default () => ({
  getKPIs(companyId = '', dateFilter) {
    return get(`/members-api/reports/kpis?dateFilter=${dateFilter}&companyFilter=${companyId}`)
  },
})
